<template>
  <div class="relative">
    <div
      class="vx-navbar-wrapper"
      :class="classObj">
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton"
        :color="navbarColorLocal"
        :class="textColor">

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer p-2 mobile-menu-button"
          icon="MenuIcon"
          @click.stop="showSidebar" />

        <bookmarks
          v-if="windowWidth >= 992"
          :navbarColor="navbarColor"
          />

        <vs-spacer />

<!--        <i18n />-->

        <!--
          ============================================================================
          NAVBAR ICONS GROUP - DROPDOWN POSITIONING GUIDE
          ============================================================================
          
          PROBLEM WE SOLVED:
          When adding the Shop dropdown, we discovered that changing icon margins
          broke dropdown alignment. After much debugging, we learned how Vuesax
          calculates dropdown positions.
          
          HOW VUESAX DROPDOWN POSITIONING WORKS:
          The vs-dropdown menu position is calculated using getBoundingClientRect()
          on the trigger element (the icon). Crucially, CSS margins on the icon
          INSIDE the vs-dropdown are included in this bounding box calculation.
          
          From vuesax.umd.js (lines 9343-9349):
          - If trigger.right < dropdownWidth + 25px → uses "rightx" positioning
          - Otherwise → menu.left = trigger.left + trigger.width
          
          This means: the icon's right margin directly affects where the dropdown
          appears. A larger margin extends the trigger's bounding box width,
          shifting the dropdown menu further to the right.
          
          THE SOLUTION - TWO TYPES OF MARGINS:
          
          1. ICON MARGINS (inside dropdown components) - affect dropdown alignment
             These are tuned specifically for each dropdown's width:
             - Wide dropdowns (365px, e.g. Notifications): mr-2 sm:mr-6
             - Narrow dropdowns (~144px, e.g. Shop, Help): mr-1 sm:mr-3
             
             DO NOT CHANGE THESE to fix spacing issues!
          
          2. COMPONENT WRAPPER MARGINS (here in TheNavbarVertical) - for spacing only
             These do NOT affect dropdown positioning because they're outside
             the vs-dropdown component. Use these to achieve even spacing.
          
          CURRENT SETUP FOR EVEN SPACING:
          - SearchBar wrapper: mr-1 sm:mr-3 (+ icon mr-1 sm:mr-3 = total mr-2 sm:mr-6)
          - Notification: no wrapper margin (icon already mr-2 sm:mr-6)
          - PurchaseButton wrapper: mr-1 sm:mr-3 (+ icon mr-1 sm:mr-3 = total mr-2 sm:mr-6)
          - HelpDropdown: no wrapper margin (icon mr-1 sm:mr-3, then ml-4 on profile)
          
          ============================================================================
        -->
        <search-bar class="mt-1 mr-1 sm:mr-3"/>

<!--        <cart-drop-down />-->

        <notification-drop-down />

        <purchase-button class="mr-1 sm:mr-3"/>

        <help-dropdown/>

        <!-- Profile section - separated from icon group -->
        <profile-drop-down class="ml-4" />

      </vs-navbar>
    </div>
  </div>
</template>

<script>
// Components
import HelpDropdown from '@/layouts/components/navbar/components/HelpDropdown.vue';
import Bookmarks from './components/Bookmarks.vue';
import SearchBar from './components/SearchBar.vue';
import NotificationDropDown from './components/notifications/NotificationDropDown.vue';
import PurchaseButton from './components/PurchaseButton.vue';
import ProfileDropDown from './components/ProfileDropDown.vue';
// import CartDropDown from './components/CartDropDown.vue';
// import I18n from './components/I18n.vue';

export default {
  name: 'the-navbar-vertical',
  components: {
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    PurchaseButton,
    ProfileDropDown,
    HelpDropdown,
    // I18n,
    // CartDropDown,
  },
  props: {
    navbarColor: {
      type: String,
      default: '#fff',
    },
  },
  computed: {
    navbarColorLocal() {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return { 'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark') };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth === 'default') return 'navbar-default';
      if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced';

      return 'navbar-full';
    },
  },
  methods: {
    showSidebar() {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
    },
  },
};
</script>

<style lang="scss">

@media (max-width: 1200px) {
  .mobile-menu-button {
    display: inline-flex !important;
  }
}
</style>
